import { FC } from 'react';
import styled from "styled-components";
import colors from "../../styles/colors";
import { useNavigate } from "react-router-dom";
import { TopDecorColor } from "../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/GenericComponentCssMatchCard";

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    width: 60%;
`

const SpaceSingleCard = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${colors.bgColorBordeaux};
    border: 4px solid ${colors.bgColorBlack2};
    width: calc(25% - 10px);
    max-width: 250px;
    height: 300px;
    padding-top: 20px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        background-color: ${colors.bgColorBlack2};
        box-shadow: 0 0 10px rgba(0,0,0,0.8);
    }
`

const BoxTopPoster = styled.div`
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;

    & img {
        width: 50%;
        min-width: 125px;
        height: 80%;
        border: 2px solid white;
        object-fit: cover;
    }
`

const BoxBottomInfo = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 20%;

    & .ppv-text {
        font-size: 16px;
        font-weight: 600;
        text-transform: uppercase;
        text-align: center;
        color: white;
        margin: 0;
    }
`

interface PpvDescription {
    name: string;
}

interface Ppv {
    id: number;
    name: string;
    img_path: string;
    date: string;
    ppv_description: PpvDescription;
}

interface AllPPvListArenaProps {
    listPpv: Ppv[];
}

const AllPPvListArena: FC<AllPPvListArenaProps> = ({ listPpv }) => {
    const navigate = useNavigate();

    const navigateToPpv = (id: number, name: string): void => {
        navigate(`/ppv/specific/i_${id}_d_${name}`);
    }

    return (
        <Container className="all-ppv-list-arena">
            {listPpv.map((ppv) => (
                <SpaceSingleCard
                    key={ppv.id}
                    onClick={() => navigateToPpv(ppv.id, ppv.name)}
                    className="space-single-card"
                >

                    <TopDecorColor />

                    <BoxTopPoster className="box-top-poster">
                        <img src={process.env.REACT_APP_STORAGE_URL + ppv.img_path} alt={ppv.img_path + "_alt"} />
                    </BoxTopPoster>

                    <BoxBottomInfo className="box-bottom-info">
                        {/* Nome piu solo anno del ppv */}
                        <p className="ppv-text ppv-name">{ppv.ppv_description.name}</p>
                        <p className="ppv-text ppv-year">{ppv.date.split('-')[2]}</p>
                    </BoxBottomInfo>

                </SpaceSingleCard>
            ))}
        </Container>
    )
}

export default AllPPvListArena;
